module.exports = __webpack_public_path__ + "static/media/school-furniture.33c769c0.jpg";